import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { OktaLoginComponent } from './okta-login/okta-login.component';


//import { loadavg } from 'os';
// Please refer to below link, section "routing milestone 6, Asynchronous routing" for more details
// https://angular.io/guide/router#milestone-6-asynchronous-routing

const appRoutes: Routes = [
  // New Registration Implementation
  {
    path: 'registration',
    loadChildren: 'app/new-registration/new-registration.module#NewRegistrationModule',
    data: {
      browserTitle: 'Registration'
    }
  },

  //revert below commente code if newlogin route not worked
  // New Login Implementation
  // {
  //   path: 'newlogin',
  //   loadChildren: 'app/new-login/new-login.module#NewLoginModule',
  // },
  // New account recovery
  {
    path: 'accountRecovery',
    loadChildren: 'app/new-account-recovery/new-account-recovery.module#NewAccountRecoveryModule',
  },
  {
    path: 'error',
    loadChildren: 'app/global-error/global-error.module#GlobalErrorModule'
  },
  /*{
    path:'enrollment',
    loadChildren:'app/landing/enrollment/enrollmentLazy.module#EnrollmentLazyLoader'
   },*/

  // Default Route
  // empty route we should redirect to landing.
  // if user is not logged in the authguard will
  // redirect them to login
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  // Wildcard Route
  // 404 Page should be added for ** route

  {
    path: 'fhirlogin',
    component: OktaLoginComponent,
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes) // , { useHash: true }) // Carl: most of latest angular application use html5 style routing
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts